/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AppId } from "../../commons/types/AppId";
import { AppType } from "./AppType";
export const App = core.serialization.object({
    id: AppId,
    name: core.serialization.string(),
    namespace: core.serialization.string(),
    type: AppType,
    entity: core.serialization.string(),
    entityPlural: core.serialization.string(),
    icon: core.serialization.string().optional(),
    metadata: core.serialization.any(),
    environmentFilters: core.serialization.any(),
    blueprint: core.serialization.any().optional(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    deletedAt: core.serialization.date().optional(),
    activatedAt: core.serialization.date().optional(),
});
